import EditIcon from "@mui/icons-material/Edit";
import { List, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import ChangePassword from "./components/changePassword/changePassword.js";
import CustomSnackbar from "../../components/Shared/customSnackbar/CustomSnackbar.js";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { externalLinks } from "../../components/Shared/Utils/externalLinks.js";
import packageJson from "../../../package.json";

import "./AccountPage.css";

const AccountPage = ({
  accessToken,
  setDisplayError,
  displayError,
  userData,
  setPopupType,
  setShowPopup,
  isUserOnMobile,
}) => {
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const handlePasswordEditClick = () => {
    setIsEditingPassword(true);
  };
  const [snackBarDisplayMessage, setSnackBarDisplayMessage] = useState("");
  const [snackBarDisplaySeverity, setSnackBarDisplaySeverity] =
    useState("error");

  const componentRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        // Clicked outside the component
        setIsEditingPassword(false);
        setDisplayError("");
      }
    };

    // Add event listener on mount
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    };
  }, [setIsEditingPassword, setDisplayError]);

  const handleCloseSnackbar = () => {
    setSnackBarDisplayMessage("");
    setSnackBarDisplaySeverity("");
  };

  return (
    <div className="accountPage">
      <List sx={{ display: "list-item;", paddingLeft: 0, marginLeft: 0 }}>
        {/* username */}
        <ListItemButton
          // key={index}
          sx={{ pl: 0, borderBottom: "var(--border)" }}
          className="request-item"
        >
          <div style={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" component="div">
              username
            </Typography>
            <Typography variant="body1" component="div">
              {userData.username || "No email set"}
            </Typography>
          </div>
        </ListItemButton>
        {/* email */}
        <ListItemButton
          // key={index}
          sx={{ pl: 0, borderBottom: "var(--border)" }}
          className="request-item"
        >
          <div style={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" component="div">
              email
            </Typography>
            <Typography variant="body1" component="div">
              {userData.email || "No email set"}
            </Typography>
          </div>
        </ListItemButton>
        {/* password */}
        <ListItemButton
          // key={index}
          ref={componentRef}
          sx={{ pl: 0, borderBottom: "var(--border)" }}
          className="request-item"
        >
          <div style={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" component="div">
              password
            </Typography>
            {isEditingPassword ? (
              <ChangePassword
                setIsEditingPassword={setIsEditingPassword}
                accessToken={accessToken}
                setDisplayError={setDisplayError}
                displayError={displayError}
                setSnackBarDisplayMessage={setSnackBarDisplayMessage}
                setSnackBarDisplaySeverity={setSnackBarDisplaySeverity}
              />
            ) : (
              <Typography variant="body1" component="div">
                {"*******"}
              </Typography>
            )}
          </div>
          {!isEditingPassword && (
            <ListItemIcon
              className="hover-icons person-add-icon"
              onClick={handlePasswordEditClick}
            >
              <EditIcon />
            </ListItemIcon>
          )}
        </ListItemButton>
      </List>

      {/* logout start */}
      <div>
        <div style={{ marginTop: "1.5rem", color: "#bdbdbd" }}>
          <p
            style={{ maxWidth: "fit-content" }}
            onClick={() => {
              setShowPopup(true);
              setPopupType("logout");
            }}
          >
            {" "}
            logout
          </p>
        </div>
        <div style={{ marginTop: "1.5rem", color: "grey" }}>
          <p
            style={{ maxWidth: "fit-content" }}
            onClick={() => {
              setShowPopup(true);
              setPopupType("deletAccount");
            }}
          >
            delete account
          </p>
        </div>
      </div>
      {/* resources start */}
      <div>
        {/* discord */}
        <div style={{ marginTop: "1.5rem", color: "#bdbdbd" }}>
          <p style={{ maxWidth: "fit-content" }}>
            {" "}
            <a
              href={externalLinks.discordLink}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#bdbdbd", textDecoration: "none" }}
            >
              {" "}
              join our discord{" "}
              <OpenInNewIcon style={{ fontSize: "15px", color: "grey" }} />
            </a>
          </p>
        </div>
        {/* donate */}
        {!isUserOnMobile && (
          <a
            href={externalLinks.donateLink}
            target="_blank"
            rel="noreferrer"
            style={{
              color: "springgreen",
              textDecoration: "none",
              marginTop: "1.5rem",
            }}
          >
            <div style={{ marginTop: "1.5rem" }}>
              <p>
                dontate to the dev{" "}
                <OpenInNewIcon style={{ fontSize: "15px", color: "grey" }} />
              </p>
            </div>
          </a>
        )}
        <div style={{ position: "absolute", bottom: "4rem", color: "grey" }}>
          version {packageJson.version}
        </div>
      </div>
      <CustomSnackbar
        open={snackBarDisplayMessage !== ""}
        message={snackBarDisplayMessage}
        severity={snackBarDisplaySeverity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default AccountPage;
